<template>
  <el-dialog title="归还资产"
             :visible.sync="returnShow"
             v-dialogDrag
             @close="closeDialog">
    <div>
      <span>单号：{{collectionCode}}</span>
    </div>
    <div class="return_add">
      <div class="return_add_num">
        <h4>归还新增</h4>
        <div>
          <span>领用数：{{recipientsTotals}}</span>
          <span>归还数：{{returnedTotals}}</span>
        </div>
      </div>
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="100px"
               class="demo-ruleForm">
        <el-row>
          <el-col :span="8">
            <el-form-item label="资产类型："
                          prop="fireassetType">
              <el-select v-model="ruleForm.fireassetType"
                         placeholder="请选择资产类型"
                         @change="assetTypeChange">
                <el-option v-for="item in assetsTypeExistOption"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="资产名称："
                          prop="fireassetNames">
              <el-select v-model="ruleForm.fireassetNames"
                         placeholder="请选择资产名称"
                         multiple
                         collapse-tags>
                <el-option v-for="item in fireassetNameOption"
                           :key="item.fireassetName"
                           :label="item.fireassetName"
                           :value="item.fireassetName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="归还时间："
                          prop="ReturnTime">
              <el-date-picker v-model="ruleForm.returnTime"
                              type="datetime"
                              placeholder="请选择归还时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="接收人："
                          prop="recieveName">
              <el-select v-model="ruleForm.recieveName"
                         placeholder="请选择接收人"
                         filterable>
                <el-option v-for="item in personList"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="归还人："
                          prop="returnName">
              <el-select v-model="ruleForm.returnName"
                         placeholder="请选择归还人"
                         filterable>
                <el-option v-for="item in personList"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="备注："
                        prop="desc">
            <el-input type="textarea"
                      v-model="ruleForm.desc"
                      :rows="1"></el-input>
          </el-form-item>
        </el-row>
        <el-form-item>
          <div style="text-align:right">
            <el-button type="primary"
                       @click="submitForm('ruleForm')">确认</el-button>
            <el-button type="info"
                       @click="resetForm('ruleForm')">重置</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="return_list">
      <h4>归还记录</h4>
      <ioc-table ref="crud"
                 v-model="returnList"
                 :data="returnData"
                 :option="option"
                 :page="page"
                 @size-change="handleSizeChange"
                 @current-change="handleCurrentChange">
      </ioc-table>
    </div>
  </el-dialog>
</template>

<script>
import { api } from "../api";
import { Dic, Dates } from '$utils'
import utils from '@src/common/utils'
import tableOption from '../const/returnOption'
export default {
  props: {
    typeExist: {
      type: Array,
      default () {
        return []
      }
    },
    personList: {
      type: Array,
      default () {
        return []
      }
    },
  },
  data () {
    return {
      // fireassetType: '',
      recipientsTotals: 0,
      returnedTotals: 0,
      returnShow: false,
      collectionCode: '',
      ruleForm: {
        fireassetType: '',
        fireassetNames: [],
        recieveName: '',
        returnName: '',
        returnTime: '',
        desc: ''
      },
      assetsType: Dic.find('SENU077'),
      // assetsTypeExist: [],//根据接口查询的当前领用人领用类型
      assetsTypeExistOption: [],
      fireassetNameOption: [],
      rules: {
        fireassetType: [
          { required: true, message: '请选择资产类型', trigger: 'blur' }
        ],
        fireassetNames: [
          { required: true, message: '请选择资产名称', trigger: 'blur' }
        ],
        recieveName: [
          { required: true, message: '请选择接收人', trigger: 'blur' }
        ],
        returnTime: [
          { required: true, message: '请选择归还时间', trigger: 'blur' }
        ],
        returnName: [
          { required: true, message: '请选择归还人', trigger: 'blur' }
        ]
      },
      returnList: {},
      returnData: [],
      option: tableOption(this),
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10
      },
    }
  },
  watch: {
  },
  mounted () {
    this.option.column[3].dicData = this.option.column[5].dicData = this.personList
  },
  methods: {
    queryRecTotal () {
      console.log('this.ruleForm', this.ruleForm)
      this.$fetch(api.assetsManage.queryRecTotalNumber,
        { collectionCode: this.collectionCode, fireassetType: this.ruleForm.fireassetType }).then(res => {
          if (res && res.success) {
            this.recipientsTotals = res.returnObj.collectionNumber
            this.returnedTotals = res.returnObj.returnNumber
          } else {
            this.$message.error(res.msgContent)
          }
        })
    },
    open (row) {
      console.log('row', row)
      this.returnShow = true
      this.collectionCode = row.collectionCode
      // this.assetsTypeExist = row.fireassetTypes
      if (this.collectionCode) {
        this.queryAssetsType(row.fireassetTypes)
        this.queryRecTotal()
        this.getReturnList()
      }
    },
    // 根据现有资产类型 过滤枚举表
    queryAssetsType (fireassetTypes) {
      this.assetsTypeExistOption = []
      //根据接口查询的当前领用人领用类型
      console.log('fireassetTypes', fireassetTypes)
      if (this.assetsType && this.assetsType.length && fireassetTypes && fireassetTypes.length) {
        this.assetsType.map(item => {
          fireassetTypes.map(numItem => {
            if (item.value === numItem.fireassetType) {
              this.assetsTypeExistOption.push(item)
            }
          })
        })
      }

    },
    // 选择资产类型时 查询对应资产名称
    assetTypeChange (val) {
      this.selectFireassetType = val
      this.$fetch(api.assetsManage.queryAssetsByType, { fireassetType: val, status: 1, collectionCode: this.collectionCode }).then(res => {
        if (res && res.success) {
          this.fireassetNameOption = res.returnObj
        } else {
          this.$message.error(res.msgContent)
        }
      })
    },
    handleSizeChange (val) {
      this.page.currentPage = 1;
      this.page.pageSize = val
      this.getReturnList()
    },
    handleCurrentChange (val) {
      this.page.currentPage = val
      this.getReturnList()
    },
    getReturnList () {
      const params = {
        collectionCode: this.collectionCode,
        pageNo: this.page.currentPage,
        pageSize: this.page.pageSize
      }
      this.$fetch(api.assetsManage.queryReturnedList, params).then(res => {
        if (res && res.success) {
          this.returnData = res.returnObj.list
        } else {
          this.$message.error(res.msgContent)
        }
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          const returnedNo = this.personList.find((item) => {
            return item.value === this.ruleForm.returnName;//筛选出匹配数据
          })
          const recieveNo = this.personList.find((item) => {
            return item.value === this.ruleForm.recieveName;//筛选出匹配数据
          })
          this.$fetch(api.assetsManage.addAssetsReturnedInfo,
            Object.assign(
              this.ruleForm,
              {
                returnWorkNo: returnedNo.value,
                returnName: returnedNo.label,
                recieveName: recieveNo.label,
                recieveWorkNo: recieveNo.value,
                collectionCode: this.collectionCode,
                returnNumber: this.ruleForm.fireassetNames.length,
                returnTime: Dates.format(this.ruleForm.returnTime, 'yyyy-MM-dd HH:mm:ss'),
              }
            )
          ).then(res => {
            if (res && res.success) {
              this.getReturnList()
              this.$message.success(res.msgContent)
              this.$refs.ruleForm.resetFields()
              this.queryRecTotal()
              this.$emit('returnAssets')
            } else {
              this.$message.error(res.msgContent)
            }
          })
        }
      });
    },
    closeDialog () {
      this.$refs.ruleForm.resetFields();
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>
<style lang="scss">
@import "../style/recipient.scss";
</style>
